import { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';

import moment from 'moment';

import { Requirement, } from '../../classess/requirement/requirement';
import { Status, } from '../../classess/status/status';
import { Customer, } from '../../classess/customer/customer';
import { UserCompanyCustomer, } from '../../classess/userCompanyCustomer/userCompanyCustomer';

import { GlobalFormats } from '../../classess/main/globalFormats';

import RequirementAdd from './RequirementAdd';
import {
    badgetStatusGeneric, getProcessButtons, dataTableLanguaje, setDateTimeFormatGlobal, getDtRowIndex, isUndNull, isUndNullEmp, getLanguageObj,
    getResponse, handleResponseMessageAsync, settings, styles, getUserRoles, LoadingSection, awaitDelayAsync
} from '../../helpers/main';
import useAuth from '../../auth/UseAuth';
import Menu from '../main/Menu';
import { User } from '../../classess/user/user';
import { RequirementService } from '../../services/requirements/RequirementService';
import TableIndex from '../main/TableIndex';
import AccessDenied from '../main/AccessDenied';

const $ = window.jqGlobal || window.jQuery;

const { app, backend, html, colors, icons, images, labels, messages, timers } = settings;

const currentMethod = 'Requirements';

export default function Requirements({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    const auth = useAuth();
    const userRole = auth?.userRole({ languageId: languageObj?.id, subMethod: currentMethod })?.result || '';
    const userRoles = getUserRoles({ userRole: userRole, subMethod: currentMethod, })?.result;
    const dtRequirementsId = 'dtRequirements';
    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({
        showLoading: true,
        add: false,
    });
    const isMount = useRef(true);
    const [modalObj, setModalObj] = useState({
        $: $,
        type: 0,
        auth: auth,
        showModal: false,
        languageObj: languageObj,
        dtRequirementsId: dtRequirementsId,
        dtRequirementsRowId: 0,
        requirement: Requirement.getClass({}, false),
        users: [User?.getClass({}, false)],
        analysts: [User?.getClass({}, false)],
        userCustomers: [User?.getClass({}, false)],
        customers: [Customer?.getClass({}, false)],
        userCompanyCustomers: [UserCompanyCustomer?.getClass({}, false)],
        userRoles: userRoles,
    });
    const controls = {
        buttons: {
            addRequirement: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnAddRequirement',
            },
        },
        dataTables: {
            requirements: {
                inputs: {
                    search: {
                        id: `${dtRequirementsId}_filter input`,
                        defaultClass: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtRequirementsId}_length select`,
                        defaultClass: '',
                    },
                },
                paginateds: {
                    paginated: {
                        id: `${dtRequirementsId}_paginate`,
                        defaultClass: '',
                    }
                }
            },
        },
        icons: {
            addRequirement: {
                id: 'iconAddEditDetails',
                defaultClass: icons?.fasFa?.plusCircle,
            },
        },
        spiners: {
            addRequirement: {
                id: 'spAddEditDetails',
                defaultClass: '',
            }
        },
    };
    //#endregion methods

    //#region methods
    //#region requirement
    const getAddRequirement = async ({
        e = {},
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getAddRequirement';
        try {
            e?.preventDefault?.();

            setProcess(prev => ({
                ...prev,
                showLoading: true,
                add: true,
            }));

            response = await RequirementService.getAdd({
                auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) return;

            const usersData = response?.result?.users?.sort((a, b) => a.firstName.toLowerCase().trim() > b.firstName.toLowerCase().trim() ? 1 : -1) || [];
            const analystsData = response?.result?.analysts?.sort((a, b) => a.firstName.toLowerCase().trim() > b.firstName.toLowerCase().trim() ? 1 : -1) || [];
            const customersData = response?.result?.customers?.sort((a, b) => a.name.toLowerCase().trim() > b.name.toLowerCase().trim() ? 1 : -1) || [];
            const userCustomersData = response?.result?.userCustomers?.sort((a, b) => a.firstName.toLowerCase().trim() > b.firstName.toLowerCase().trim() ? 1 : -1) || [];
            const userCompanyCustomersData = response?.result?.userCompanyCustomers || [];

            setModalObj(prev => ({
                ...prev,
                type: 0,
                showModal: true,
                requirement: {
                    ...Requirement.getClass({}, false),
                    analystId: (userRoles?.isAdmin || userRoles?.isAnalyst) ? '' : analystsData[0]?.id || '',
                    userId: (userRoles?.isAdmin || userRoles?.isAnalyst) ? '' : usersData[0]?.id || '',
                    informCreationDate: new Date().toISOString(),
                    informCreationUserId: auth?.user?.id,
                    register: new Date().toISOString(),
                    registerDate: new Date().toISOString(),
                    userRegisterDate: moment(new Date())?.format(`${languageObj?.format?.date?.f13} ${languageObj?.format?.time?.f2}`),
                    userVisitDate: new Date().toISOString(),
                    visitDate: moment(new Date())?.format(`${languageObj?.format?.date?.f13} ${languageObj?.format?.time?.f2}`),
                },
                users: usersData,
                analysts: analystsData,
                customers: customersData,
                userCustomers: userCustomersData,
                userCompanyCustomers: userCompanyCustomersData,
            }));

        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({
                ...prev,
                showLoading: false,
                add: false,
            }));

            // CSN (Condición Estándar de Notificación):
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    const getRequirementEditDetails = async ({
        e = {},
        id = '',
        type = 0,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getRequirementEditDetails';
        try {
            e?.preventDefault?.();
            const urlRequeriments = {
                edit: `${backend?.urls?.requirements}/${labels?.edit?.en?.toLowerCase()}/${id}`,
                details: `${backend?.urls?.requirements}/${labels?.details?.en?.toLowerCase()}/${id}`,
            };

            setProcess(prev => ({ ...prev, showLoading: true, }));
            await awaitDelayAsync({ delayTime: timers?.oneSecond });

            // Direct navigation logic preserved
            window.location.href = type === 1 ? urlRequeriments?.edit : urlRequeriments?.details;

        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({
                ...prev,
                showLoading: false,
            }));

            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                });
            }
        }
    }

    const deleteRequirement = async ({
        e = {},
        id = '',
        description = '',
        rowId = 0,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'deleteRequirement';
        try {
            e?.preventDefault?.();

            //#region show message
            const msgTextObj = {
                one: messages?.areYouShureDeleteThis?.[languageObj?.id],
                two: `${labels?.requirement?.[languageObj?.id]}: <b>${description}</b><br/>`,
                three: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            const swalProperties = {
                icon: settings.react.sweetAlert2.messages.types.warning,
                title: msgTextObj?.one,
                html: `${msgTextObj?.two}${msgTextObj?.three}`,
                timer: null,
                showConfirmButton: !Swal.isLoading(),
                confirmButtonColor: colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: !Swal.isLoading(),
                cancelButtonColor: colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                customClass: {
                    confirmButton: html?.buttons?.primary,
                    cancelButton: html?.buttons?.secondary,
                },
                didOpen: () => {
                    Swal.hideLoading();
                },
                allowOutsideClick: () => !Swal.isLoading(),
                preConfirm: async () => {
                    let preConfirmResponse = getResponse({ type: 0 });
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal.update({
                            icon: settings?.react?.sweetAlert2?.messages?.types?.info,
                            title: `${messages?.processingPleaseWait?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.two}`,
                            showConfirmButton: false,
                        });

                        //#region delete data (requirement)
                        preConfirmResponse = await RequirementService.deleteAsync({
                            auth,
                            id: id,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });

                        if (!preConfirmResponse?.isSuccess || preConfirmResponse?.isWarning) return preConfirmResponse;
                        //#endregion delete data (requirement)

                        //#region delete datatable (requirement)
                        $(`#${dtRequirementsId}`)?.DataTable()?.row(rowId)?.remove()?.draw(true);

                        preConfirmResponse.msgText = `${messages?.processCompletedSuccessfully?.[languageObj?.id]}.`;
                        //#endregion delete datatable (requirement)
                    } catch (ex) {
                        preConfirmResponse = getResponse({ type: -1 });
                        preConfirmResponse.msgText = `Method: ${currentMethod}<br/>`;
                        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                            preConfirmResponse.msgText += `Sub method: ${subMethod}<br/>`;
                        }
                        preConfirmResponse.msgText += `Error: ${ex?.message}<br/>`;
                    }
                    return preConfirmResponse;
                },
            };

            const swalResult = await Swal.fire(swalProperties);

            if (swalResult?.isConfirmed && swalResult?.value) {
                response = swalResult?.value;
            } else if (swalResult?.isDismissed) {
                response = getResponse({ type: 0 });
            }
            //#endregion show message
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                });
            }
        }
    }
    //#endregion requirement

    //#region others
    const getData = async () => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getData';
        try {
            setProcess(prev => ({
                ...prev,
                showLoading: true,
            }));

            if (auth?.isLoged({ subMethod: currentMethod })?.result) {
                //#region datatable (set)
                response = setDataTables({
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion datatable (set)

                //#region set query code
                response = setQueryCode({
                    subMethod: currentMethod,
                });
                if (!response?.isSuccess || response?.isWarning) return;
                //#endregion set query code

                //#region get data (requirement)
                response = await RequirementService.getAll({
                    auth,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) return;

                const requirementsData = response?.result?.requirements || [];
                const statusData = response?.result?.status || [];
                //#endregion get data (requirement)

                //#region set datatable
                if (!isUndNullEmp({ data: requirementsData, subMethod: currentMethod })?.result &&
                    requirementsData.length > 0) {
                    response = setDataInDataTable({
                        data: requirementsData,
                        status: statusData,
                        subMethod: currentMethod,
                    });
                    if (!response?.isSuccess || response?.isWarning) return;
                }
                //#endregion set datatable
            } else {
                setShowData(false);
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({
                ...prev,
                showLoading: false,
            }));

            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                    setShowData,
                    showDataValue: response?.isSuccess,
                });
            }
        }
    }

    const setDataTables = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDataTables';
        try {
            $(`#${dtRequirementsId}`).DataTable({
                //buttons: ['copy', 'csv', 'excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.number?.[languageObj?.id], width: '10%', },
                    { title: labels?.status?.[languageObj?.id], width: '15%', },
                    { title: labels?.visitDate?.[languageObj?.id], width: '15%', },
                    { title: labels?.contactPerson?.[languageObj?.id], width: '55%', },
                    { title: labels?.process[languageObj?.id], className: 'text-center', width: '5%', orderable: false, searchable: false, },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ code: languageObj?.id, }),
                order: [[0, 'desc']],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
            });
            //.buttons().container().appendTo(`#${dtRequirementsId}_wrapper .col-md-6:eq(0)`);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setQueryCode = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setQueryCode';
        try {
            $(`#${dtRequirementsId} tbody`).on('click', 'tr', 'td', async function (e) {
                const rowId = getDtRowIndex({ dtId: dtRequirementsId, _this: this, subMethod: currentMethod })?.result;
                if (!isUndNull({ data: rowId, subMethod: currentMethod })?.result) {
                    const methodName = e?.target?.attributes?.method?.value || '';
                    const id_ = e?.target?.attributes?.id?.value || '';
                    const description = e?.target?.attributes?.description?.value || '';
                    switch (methodName) {
                        case 'edit':
                            getRequirementEditDetails({ e: e, id: id_, description: description, type: 1, rowId: rowId, subMethod: currentMethod, });
                            break;
                        case 'details':
                            getRequirementEditDetails({ e: e, id: id_, description: description, type: 2, rowId: rowId, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            deleteRequirement({ e: e, id: id_, description: description, rowId: rowId, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDataInDataTable = ({
        data = [],
        status = [],
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setDataInDataTable';
        try {
            //#region variables
            // let requirementDt = [];
            //#endregion variables

            //#region process
            const requirementDt = data.map((requirement) => {
                const modelRequirement = Requirement.getClass(requirement, false);
                const modelStatus = Status?.getClass(status.filter(({ id }) => id === modelRequirement?.statusId)[0] || {}, false);
                const statusLabel = !isUndNullEmp({ data: modelStatus?.label, subMethod: currentMethod }) ?
                    modelStatus.label :
                    `${modelStatus?.name.replace(' ', '')?.charAt(0)?.toLowerCase()}${modelStatus?.name.replace(' ', '').slice(1)}`;

                return [
                    `<b>${modelRequirement.id}</b>`,
                    badgetStatusGeneric({
                        type: (modelRequirement?.statusId || 5) === 1 ?
                            1 : (modelRequirement?.statusId || 5) === 2 ?
                                5 : (modelRequirement?.statusId || 5) === 3 ?
                                    3 : (modelRequirement?.statusId || 5) === 4 ?
                                        0 : (modelRequirement?.statusId || 5) === 5 ?
                                            -1 : (modelRequirement?.statusId || 5) === 6 ?
                                                2 : (modelRequirement?.statusId || 5),
                        value: labels?.[statusLabel]?.[languageObj?.id] || 'undefined',
                    }),
                    setDateTimeFormatGlobal({
                        date: modelRequirement.visitDate,
                        type: languageObj?.format?.date?.f1,
                        format: 0,
                        addTime: false,
                        withSeconds: false,
                        subMethod: currentMethod,
                    })?.result,
                    modelRequirement.contactPerson,
                    getProcessButtons({
                        id: modelRequirement.id,
                        description: modelRequirement.id,
                        showDetails: true,
                        labelDetails: labels?.details[languageObj?.id],
                        enabledDetails: true,
                        showDelete: (userRoles?.isAdmin || userRoles?.isAnalyst),
                        labelDelete: labels?.delete[languageObj?.id],
                        enabledDelete: (userRoles?.isAdmin || userRoles?.isAnalyst),
                        showEdit: (userRoles?.isAdmin || userRoles?.isAnalyst),
                        labelEdit: labels?.edit?.[languageObj?.id],
                        enabledEdit: (userRoles?.isAdmin || userRoles?.isAnalyst),
                        processButtons: [],
                    })?.result,
                ];
            });

            $(`#${dtRequirementsId}`)?.DataTable()?.rows?.add(requirementDt)?.draw(true);
            //#endregion process
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods
    return (
        <div>
            <Menu viewName={app?.views?.requirements?.requirements} process={app?.views?.requirements?.requirements} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.requirements?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.requirements?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {auth?.isLoged({ subMethod: currentMethod })?.result ? (
                            <div className='row'>
                                <div className='col-12'>
                                    {showData ? (
                                        <div className={html?.cards?.default} style={{ borderRadius: '10px' }}>
                                            <LoadingSection alt='loadingSection'
                                                className='overlay dark text-white'
                                                height={20}
                                                hidden={!process?.showLoading}
                                                width={20}
                                                languageId={languageObj?.id}
                                                subMethod={currentMethod} />

                                            <div className='card-header bg-white border-bottom-0 pt-4 px-4'>
                                                <div className='d-flex align-items-center'>
                                                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                        <img alt={labels?.requirements?.[languageObj?.id]} style={styles?.cardHeaderLogo} src={images?.icons?.requirements} />
                                                    </div>
                                                    <div className='d-flex flex-column'>
                                                        <h5 className='mb-0 font-weight-bold text-dark'>{labels?.requirements?.[languageObj?.id]}</h5>
                                                        <div className='mt-1'>
                                                            <span className='badge badge-pill badge-info px-2 py-1 text-uppercase' style={html?.badges?.micro}>
                                                                <i className={`${icons?.fasFa?.tasks} mr-1`}></i> {labels?.index?.[languageObj?.id] || 'Index'}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className='d-flex flex-wrap justify-content-end align-items-center ml-auto' style={{ gap: '8px' }}>
                                                        <button id={controls?.buttons?.addRequirement?.id}
                                                            type='button'
                                                            className={process?.add ? `${controls?.buttons?.addRequirement?.defaultClass} ${settings?.react?.settings?.react?.html?.button?.classes?.disabled}` : controls?.buttons?.addRequirement?.defaultClass}
                                                            title={labels?.add?.[languageObj?.id]}
                                                            disabled={process?.add}
                                                            onClick={(e) => getAddRequirement({ e: e, subMethod: controls?.buttons?.addRequirement?.id })}
                                                            style={{ borderRadius: '5px' }}>
                                                            {process?.add ? (
                                                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                                                            ) : (
                                                                <i id={controls?.icons?.addRequirement?.id} className={`${controls?.icons?.addRequirement?.defaultClass}`} />
                                                            )} {labels?.add?.[languageObj?.id]}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className='card-body px-4 pb-4'>
                                                <TableIndex tableId={dtRequirementsId} languageObj={languageObj} />
                                            </div>
                                        </div>
                                    ) : (
                                        <div></div>
                                    )}
                                </div>
                            </div>
                        ) : (
                            <AccessDenied languageObj={languageObj} />
                        )}

                    </div>
                </section>

            </div>

            {modalObj?.showModal ?
                <RequirementAdd
                    modalObj={modalObj}
                    setModalObj={setModalObj} />
                :
                <div></div>
            }
        </div>
    )
}
